// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2SJ9d","buttons":"PendingPaymentAlert_buttons__1rcaM"};